import { ADD_TYPE_PROPERTY_SUCCESS, DELETE_TYPE_PROPERTY_SUCCESS, GET_TYPE_PROPERTIES_SUCCESS, 
    MODAL_TYPE_PROPERTY_SHOW, UPDATE_TYPE_PROPERTY_SUCCESS, GET_TYPE_PROPERTIES_3_SUCCESS, 
GET_TYPE_PROPERTIES_SELECT_SUCCESS} from "./actions";

const INIT_STATE = {
    typeProperties: [],
    typePropertiesBySelect: [],
    typePropertiesLevel3: [],
    error: {},
    totalItems:0,
    typePropertyModalShow:false,
    typePropertySaved: false
};


const TypePropertyReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TYPE_PROPERTIES_SUCCESS:
            return {
                ...state,
                typeProperties: action.payload.data.data.data,
                totalItems: action.payload.data.data.total,
            };
        case GET_TYPE_PROPERTIES_SELECT_SUCCESS:
            return {
                ...state,
                typePropertiesBySelect: action.payload.data.data
            };
        case GET_TYPE_PROPERTIES_3_SUCCESS:
            return {
                ...state,
                typePropertiesLevel3: action.payload.data.data,
                totalItems: action.payload.data.data.total,
            };
        case ADD_TYPE_PROPERTY_SUCCESS:
            return {
                ...state,
                typeProperties: action.payload.data,
                totalItems: action.payload.data?.total,
                typePropertySaved: action.payload.success,
            };
        case UPDATE_TYPE_PROPERTY_SUCCESS:
            return {
                    ...state,
                    typeProperties: action.payload.data,
                    typePropertySaved: action.payload.success,
                };
        case DELETE_TYPE_PROPERTY_SUCCESS:
            return {
                    ...state,
                    typeProperties: action.payload
                }
        case MODAL_TYPE_PROPERTY_SHOW:
            return {
                        ...state,
                        typePropertyModalShow: action.payload,
                    }   
        default:
            return state;
    }
};

export default TypePropertyReducer;